import React from 'react'
import { Posts } from '../HomeScreen/PostsData/Posts'

const Groupe = () => {
  return (
    <div className='col-sm-12 col-md-8 col-lg-6  groups mx-lg-auto mt-5'>
      <Posts/>
    </div>
  )
}

export default Groupe